/* eslint-disable consistent-return */
import React from 'react';

import LayoutStep from './dashboard-steps/LayoutStep';
import InformationStep from './dashboard-steps/InformationStep';
import DefaultConfigurationStep from './dashboard-steps/DefaultConfigurationStep';
import DateSettingsStep from './dashboard-steps/DateSettingsStep';

import FirstStep from './widget-steps/FirstStep';
import SecondStep from './widget-steps/SecondStep';
import ThirdStep from './widget-steps/ThirdStep';

export const dashboardCreationSteps = ({
  activeStep,
  dispatchDashboard,
  dashboardData,
  setActiveStep,
  setWhichPopup,
  isUpdate
}) => {
  switch (activeStep) {
    case 0:
      return (
        <LayoutStep
          setActiveStep={setActiveStep}
          dispatchDashboard={dispatchDashboard}
          {...dashboardData}
        />
      );
    case 1:
      return (
        <InformationStep
          isFirstStep={false}
          setActiveStep={setActiveStep}
          dispatchDashboard={dispatchDashboard}
          {...dashboardData}
        />
      );
    case 2:
      return (
        <DefaultConfigurationStep
          setActiveStep={setActiveStep}
          dispatchDashboard={dispatchDashboard}
          dashboardData={dashboardData}
        />
      );
    case 3:
      return (
        <DateSettingsStep
          dispatchDashboard={dispatchDashboard}
          dashboardData={dashboardData}
          setActiveStep={setActiveStep}
          setWhichPopup={setWhichPopup}
          isUpdate={isUpdate}
        />
      );

    default:
      break;
  }
};

export const dashboardUpdateSteps = ({
  activeStep,
  dispatchDashboard,
  dashboardData,
  setActiveStep,
  setWhichPopup,
  isUpdate
}) => {
  switch (activeStep) {
    case 0:
      return (
        <InformationStep
          isFirstStep
          setActiveStep={setActiveStep}
          dispatchDashboard={dispatchDashboard}
          {...dashboardData}
        />
      );
    case 1:
      return dashboardData.isCanned ? (
        <DateSettingsStep
          dispatchDashboard={dispatchDashboard}
          dashboardData={dashboardData}
          setActiveStep={setActiveStep}
          setWhichPopup={setWhichPopup}
          isUpdate={isUpdate}
        />
      ) : (
        <DefaultConfigurationStep
          setActiveStep={setActiveStep}
          dispatchDashboard={dispatchDashboard}
          dashboardData={dashboardData}
        />
      );
    case 2:
      return (
        <DateSettingsStep
          dispatchDashboard={dispatchDashboard}
          dashboardData={dashboardData}
          setActiveStep={setActiveStep}
          setWhichPopup={setWhichPopup}
          isUpdate={isUpdate}
        />
      );

    default:
      break;
  }
};

export const widgetCreationSteps = ({
  activeStep,
  dispatchDashboard,
  setActiveStep,
  setWhichPopup,
  baseWidgetId,
  dispatchWidget,
  baseWidgetWidth,
  setBaseWidgetWidth,
  widgetState,
  handleWidgetClose,
  dashboardData,
  panelIndex
}) => {
  switch (activeStep) {
    case 0:
      return (
        <FirstStep
          setActiveStep={setActiveStep}
          baseWidgetId={baseWidgetId}
          dispatchWidget={dispatchWidget}
          setWhichPopup={setWhichPopup}
          widgetState={widgetState}
          dashboardData={dashboardData}
        />
      );
    case 1:
      return (
        <SecondStep
          setActiveStep={setActiveStep}
          dispatchWidget={dispatchWidget}
          widgetState={widgetState}
          baseWidgetWidth={baseWidgetWidth}
          setBaseWidgetWidth={setBaseWidgetWidth}
        />
      );
    case 2:
      return (
        <ThirdStep
          widgetState={widgetState}
          dispatchWidget={dispatchWidget}
          dispatchDashboard={dispatchDashboard}
          setWhichPopup={setWhichPopup}
          handleWidgetClose={handleWidgetClose}
          setActiveStep={setActiveStep}
          panelIndex={panelIndex}
          dashboardTimeSeriesSetId={dashboardData.timeSeriesSetId}
        />
      );

    default:
      break;
  }
};
